import styled from "@emotion/styled";
import MKTypography from "components/MKTypography";

export const StyledOurServicesParagraph = styled(MKTypography)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    height: "155px",
  },
}));
